import React from "react";
import {
    Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, Stack,
    Container
} from "@mui/material";
import TableDataWithPagination from "../../BuiltInComponent/TableWithPagination";
import Loading from '../../BuiltInComponent/Loading';
import HeadingText from '../../BuiltInComponent/HeadingTest';
import ModernNavbar from '../setup/ModernNavbar';
import { Grid2 } from "@mui/material";
import TextFields from "../../BuiltInComponent/TextField";
import { useDispatch, useSelector } from "react-redux";

import {
    getLeaves,
    getSingleleave,
    addLeave,
    editLeave,
    deleteLeave
} from "../../features/AdminManagement/leaveSlice"; // <- updated slice import

const defaultForm = {
    leaveID: "",
    leaveDescription: "",
    leaveStatus: 1,
};

export default function LeavesManagementList() {
    const dispatch = useDispatch();
    const { leaves, isLoading } = useSelector((state) => state.emp);

    const [rows, setRows] = React.useState([]);
    const [open, setOpen] = React.useState(false);
    const [formData, setFormData] = React.useState(defaultForm);
    const [editMode, setEditMode] = React.useState(false);

    // ===== Load leaves safely =====
    const loadLeaves = () => {
        dispatch(getLeaves()).then((res) => {
            const data = Array.isArray(res.payload) ? res.payload : [];
            const mapped = data.map((x) => ({
                ...x,
                edit: "Edit",
                delete: "Delete",
            }));
            setRows(mapped);
        });
    };

    React.useEffect(() => {
        loadLeaves();
    }, [dispatch]);

    // ========= Handlers =========
    const handleOpenAdd = () => {
        setEditMode(false);
        setFormData(defaultForm);
        setOpen(true);
    };

    const onEdit = (id) => {
        setEditMode(true);
        dispatch(getSingleleave(id)).then((res) => {
            const d = res.payload || {};
            setFormData({
                leaveID: d.leaveID ?? "",
                leaveDescription: d.leaveDescription ?? "",
                leaveStatus: Number(d.leaveStatus ?? 1),
            });
        });
        setOpen(true);
    };

    const onDelete = async (id) => {
        try {
            dispatch(deleteLeave(id)).then(() => {
                loadLeaves();
            });
        } catch (e) {
            console.error(e);
            alert(e.message);
        }
    };

    const onChange = (e) => {
        const [key, value] = Object.entries(e)[0];
        const v = key === "leaveStatus" ? Number(value) : value;
        setFormData((s) => ({ ...s, [key]: v }));
    };

    const handleSave = async () => {
        const payload = {
            leaveDescription: formData.leaveDescription?.trim(),
            leaveStatus: Number(formData.leaveStatus ?? 1),
        };

        if (!payload.leaveDescription) {
            alert("Description required");
            return;
        }

        try {
            if (editMode) {
                dispatch(editLeave({ id: formData.leaveID, ...payload })).then(() => {
                    loadLeaves();
                });
            } else {
                dispatch(addLeave(payload)).then(() => {
                    loadLeaves();
                });
            }
            setOpen(false);
        } catch (e) {
            console.error(e);
            alert(e.message);
        }
    };

    // ========= Table Columns =========
    const tableColumns = [
        { fieldName: "leaveID", cName: "ID", width: 10, textAlign: "left", status: "en" },
        { fieldName: "leaveDescription", cName: "Description", width: 30, textAlign: "left", status: "en" },
        { fieldName: "leaveStatus", cName: "Status", width: 15, textAlign: "left", status: "en" },
        { fieldName: "edit", cName: "Edit", width: 10, textAlign: "center", status: "en" },
        { fieldName: "delete", cName: "Delete", width: 10, textAlign: "center", status: "en" },
        { fieldName: "delete", cName: "Delete", width: 10, textAlign: "center", status: "dis" },
    ];

    return (
        <>
            <ModernNavbar />
            <Container>
                <Box p={2}>
                    <HeadingText text="Leaves Management" />
                    <Stack direction="row" justifyContent="right" alignItems="center" mb={2} mt={2}>
                        <Button variant="contained" onClick={handleOpenAdd}>Add Leave</Button>
                    </Stack>
                    {isLoading ? <Loading /> :
                        <TableDataWithPagination
                            tableData={rows}
                            tableColumns={tableColumns}
                            onEditClick={onEdit}
                            onDeleteClick={onDelete}
                            perPage={5}
                        />
                    }

                    <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
                        <DialogTitle>{editMode ? "Edit Leave" : "Add Leave"}</DialogTitle>
                        <DialogContent dividers>
                            <LeaveForm formData={formData} onChange={onChange} />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setOpen(false)}>Cancel</Button>
                            <Button variant="contained" onClick={handleSave}>
                                {editMode ? "Update" : "Save"}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Box>
            </Container>
        </>
    );
}

function LeaveForm({ formData, onChange }) {
    return (
        <Grid2 container spacing={2}>
            <Grid2 size={12}>
                <TextFields
                    label="Leave ID"
                    name="leaveID"
                    value={formData.leaveID ?? ""}
                    onChange={onChange}
                    disStatus={true}
                />
            </Grid2>
            <Grid2 size={12}>
                <TextFields
                    label="Leave Description"
                    name="leaveDescription"
                    value={formData.leaveDescription ?? ""}
                    onChange={onChange}
                    disStatus={false}
                />
            </Grid2>
        </Grid2>
    );
}
